/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: Ti20hJKJUiCi
import * as React from "react";
import {
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as plasmicAuth from "@plasmicapp/react-web/lib/auth";
import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import Op1WebForumPostPreview from "../../FormPostPreview"; // plasmic-import: dibWfFuvP_0V/component
import Op1WebDock from "../../Op1WebDock"; // plasmic-import: WsKrqHiP5PVH/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicOp1WebForum.module.css"; // plasmic-import: Ti20hJKJUiCi/css
import penNibZD51NOotXvYj from "./images/penNib.svg"; // plasmic-import: zD51nOotXvYj/picture

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    openGraph: {},
    twitter: {
      card: "summary"
    }
  };
}

createPlasmicElementProxy;

export const PlasmicOp1WebForum__VariantProps = new Array();

export const PlasmicOp1WebForum__ArgProps = new Array();

const $$ = {};

function PlasmicOp1WebForum__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          "all",
          "root_reset_nJ1Nn58LcfAm7wemZm71QH",
          "plasmic_default_styles",
          "plasmic_mixins",
          styleTokensClassNames,
          sty.root
        )}
      >
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames("all", sty.freeBox, "auto-scroll")}
        >
          <div
            data-plasmic-name={"pageContentWrapper"}
            data-plasmic-override={overrides.pageContentWrapper}
            className={classNames("all", sty.pageContentWrapper)}
          >
            <div
              data-plasmic-name={"sectionHero"}
              data-plasmic-override={overrides.sectionHero}
              className={classNames("all", sty.sectionHero)}
            >
              <div
                data-plasmic-name={"frame426"}
                data-plasmic-override={overrides.frame426}
                className={classNames("all", sty.frame426)}
              >
                <div
                  data-plasmic-name={"frame427"}
                  data-plasmic-override={overrides.frame427}
                  className={classNames("all", sty.frame427)}
                >
                  <div
                    data-plasmic-name={"text"}
                    data-plasmic-override={overrides.text}
                    className={classNames("all", "__wab_text", sty.text)}
                  >
                    {"let's talk about it."}
                  </div>
                  <div
                    data-plasmic-name={"forumActions"}
                    data-plasmic-override={overrides.forumActions}
                    className={classNames("all", sty.forumActions)}
                  >
                    <div
                      data-plasmic-name={"frame313"}
                      data-plasmic-override={overrides.frame313}
                      className={classNames("all", sty.frame313)}
                    >
                      <div
                        data-plasmic-name={"frame428"}
                        data-plasmic-override={overrides.frame428}
                        className={classNames("all", sty.frame428)}
                      >
                        <div
                          data-plasmic-name={"globalButton"}
                          data-plasmic-override={overrides.globalButton}
                          className={classNames("all", sty.globalButton)}
                        >
                          <div
                            data-plasmic-name={"_continue"}
                            data-plasmic-override={overrides._continue}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty._continue
                            )}
                          >
                            {"latest"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"globalButton2"}
                          data-plasmic-override={overrides.globalButton2}
                          className={classNames("all", sty.globalButton2)}
                        >
                          <div
                            data-plasmic-name={"continue2"}
                            data-plasmic-override={overrides.continue2}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.continue2
                            )}
                          >
                            {"announcements"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"globalButton3"}
                          data-plasmic-override={overrides.globalButton3}
                          className={classNames("all", sty.globalButton3)}
                        >
                          <div
                            data-plasmic-name={"continue3"}
                            data-plasmic-override={overrides.continue3}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.continue3
                            )}
                          >
                            {"public"}
                          </div>
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"buttonActionPictogram"}
                        data-plasmic-override={overrides.buttonActionPictogram}
                        className={classNames("all", sty.buttonActionPictogram)}
                      >
                        <PlasmicImg__
                          data-plasmic-name={"img"}
                          data-plasmic-override={overrides.img}
                          alt={""}
                          className={classNames(sty.img)}
                          displayHeight={"16px"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"100%"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"16px"}
                          loading={"lazy"}
                          src={{
                            src: penNibZD51NOotXvYj,
                            fullWidth: 16,
                            fullHeight: 16,
                            aspectRatio: undefined
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              data-plasmic-name={"sectionPostPreviews"}
              data-plasmic-override={overrides.sectionPostPreviews}
              className={classNames("all", sty.sectionPostPreviews)}
            >
              <Op1WebForumPostPreview
                className={classNames(
                  "__wab_instance",
                  sty.op1WebForumPostPreview__j1ORw
                )}
              />

              <Op1WebForumPostPreview
                className={classNames(
                  "__wab_instance",
                  sty.op1WebForumPostPreview__qowr7
                )}
                showTitle={false}
              />

              <Op1WebForumPostPreview
                className={classNames(
                  "__wab_instance",
                  sty.op1WebForumPostPreview___2Myzt
                )}
              />
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"temporaryDockWrapper"}
          data-plasmic-override={overrides.temporaryDockWrapper}
          className={classNames("all", sty.temporaryDockWrapper)}
        >
          <Op1WebDock
            data-plasmic-name={"op1WebDock"}
            data-plasmic-override={overrides.op1WebDock}
            className={classNames("__wab_instance", sty.op1WebDock)}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "freeBox",
    "pageContentWrapper",
    "sectionHero",
    "frame426",
    "frame427",
    "text",
    "forumActions",
    "frame313",
    "frame428",
    "globalButton",
    "_continue",
    "globalButton2",
    "continue2",
    "globalButton3",
    "continue3",
    "buttonActionPictogram",
    "img",
    "sectionPostPreviews",
    "temporaryDockWrapper",
    "op1WebDock"
  ],

  freeBox: [
    "freeBox",
    "pageContentWrapper",
    "sectionHero",
    "frame426",
    "frame427",
    "text",
    "forumActions",
    "frame313",
    "frame428",
    "globalButton",
    "_continue",
    "globalButton2",
    "continue2",
    "globalButton3",
    "continue3",
    "buttonActionPictogram",
    "img",
    "sectionPostPreviews"
  ],

  pageContentWrapper: [
    "pageContentWrapper",
    "sectionHero",
    "frame426",
    "frame427",
    "text",
    "forumActions",
    "frame313",
    "frame428",
    "globalButton",
    "_continue",
    "globalButton2",
    "continue2",
    "globalButton3",
    "continue3",
    "buttonActionPictogram",
    "img",
    "sectionPostPreviews"
  ],

  sectionHero: [
    "sectionHero",
    "frame426",
    "frame427",
    "text",
    "forumActions",
    "frame313",
    "frame428",
    "globalButton",
    "_continue",
    "globalButton2",
    "continue2",
    "globalButton3",
    "continue3",
    "buttonActionPictogram",
    "img"
  ],

  frame426: [
    "frame426",
    "frame427",
    "text",
    "forumActions",
    "frame313",
    "frame428",
    "globalButton",
    "_continue",
    "globalButton2",
    "continue2",
    "globalButton3",
    "continue3",
    "buttonActionPictogram",
    "img"
  ],

  frame427: [
    "frame427",
    "text",
    "forumActions",
    "frame313",
    "frame428",
    "globalButton",
    "_continue",
    "globalButton2",
    "continue2",
    "globalButton3",
    "continue3",
    "buttonActionPictogram",
    "img"
  ],

  text: ["text"],
  forumActions: [
    "forumActions",
    "frame313",
    "frame428",
    "globalButton",
    "_continue",
    "globalButton2",
    "continue2",
    "globalButton3",
    "continue3",
    "buttonActionPictogram",
    "img"
  ],

  frame313: [
    "frame313",
    "frame428",
    "globalButton",
    "_continue",
    "globalButton2",
    "continue2",
    "globalButton3",
    "continue3",
    "buttonActionPictogram",
    "img"
  ],

  frame428: [
    "frame428",
    "globalButton",
    "_continue",
    "globalButton2",
    "continue2",
    "globalButton3",
    "continue3"
  ],

  globalButton: ["globalButton", "_continue"],
  _continue: ["_continue"],
  globalButton2: ["globalButton2", "continue2"],
  continue2: ["continue2"],
  globalButton3: ["globalButton3", "continue3"],
  continue3: ["continue3"],
  buttonActionPictogram: ["buttonActionPictogram", "img"],
  img: ["img"],
  sectionPostPreviews: ["sectionPostPreviews"],
  temporaryDockWrapper: ["temporaryDockWrapper", "op1WebDock"],
  op1WebDock: ["op1WebDock"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOp1WebForum__ArgProps,
          internalVariantPropNames: PlasmicOp1WebForum__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOp1WebForum__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOp1WebForum";
  } else {
    func.displayName = `PlasmicOp1WebForum.${nodeName}`;
  }
  return func;
}

function withUsePlasmicAuth(WrappedComponent) {
  const WithUsePlasmicAuthComponent = props => {
    const dataSourceCtx = usePlasmicDataSourceContext() ?? {};
    const { isUserLoading, user, token } = plasmicAuth.usePlasmicAuth({
      appId: "nJ1Nn58LcfAm7wemZm71QH"
    });
    return (
      <PlasmicDataSourceContextProvider__
        value={{
          ...dataSourceCtx,
          isUserLoading,
          userAuthToken: token,
          user
        }}
      >
        <WrappedComponent {...props} />
      </PlasmicDataSourceContextProvider__>
    );
  };
  return WithUsePlasmicAuthComponent;
}

export const PlasmicOp1WebForum = Object.assign(
  // Top-level PlasmicOp1WebForum renders the root element
  withUsePlasmicAuth(makeNodeComponent("root")),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    pageContentWrapper: makeNodeComponent("pageContentWrapper"),
    sectionHero: makeNodeComponent("sectionHero"),
    frame426: makeNodeComponent("frame426"),
    frame427: makeNodeComponent("frame427"),
    text: makeNodeComponent("text"),
    forumActions: makeNodeComponent("forumActions"),
    frame313: makeNodeComponent("frame313"),
    frame428: makeNodeComponent("frame428"),
    globalButton: makeNodeComponent("globalButton"),
    _continue: makeNodeComponent("_continue"),
    globalButton2: makeNodeComponent("globalButton2"),
    continue2: makeNodeComponent("continue2"),
    globalButton3: makeNodeComponent("globalButton3"),
    continue3: makeNodeComponent("continue3"),
    buttonActionPictogram: makeNodeComponent("buttonActionPictogram"),
    img: makeNodeComponent("img"),
    sectionPostPreviews: makeNodeComponent("sectionPostPreviews"),
    temporaryDockWrapper: makeNodeComponent("temporaryDockWrapper"),
    op1WebDock: makeNodeComponent("op1WebDock"),
    // Metadata about props expected for PlasmicOp1WebForum
    internalVariantProps: PlasmicOp1WebForum__VariantProps,
    internalArgProps: PlasmicOp1WebForum__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/community/forum",
      pagePath: "/community/forum",
      params: {},
      query: {}
    })
  }
);

export default PlasmicOp1WebForum;
/* prettier-ignore-end */
